










































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import PortalContainer from '@/mobile/src/components/containers/PortalContainer.vue'
import BaseButton from '@/components/Rain/Buttons/BaseButton.vue'
import Typography from '@/components/Rain/Typography/Typography.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'

@Component<Modal>({
    components: {
        BaseButton,
        Typography,
        PortalContainer,
        FontAwesomeIcon
    }
})
export default class Modal extends Vue {
    @Prop({ type: Boolean, default: false }) public readonly show!: boolean
    @Prop({ type: String, default: '' }) public readonly title!: string
    @Prop({ type: String, default: 'ghost' })
    public readonly btnLeftType!: string
    @Prop({ type: String, default: '' })
    public readonly btnLeft!: string
    @Prop({ type: String, default: 'confirm' })
    public readonly btnRight!: string
    @Prop({ type: Boolean, default: true })
    public readonly btnFull!: boolean

    public faTimes = faTimes
}
